module.exports = __webpack_public_path__ + "static/media/legal.06e94828.svg";